import { useFormErrorNotif } from "@babackapp/react-hook-forms-components/form-notifications";
import useTranslation from "@babackapp/translations/use-translation";
import { resolveLabelGenerationFailure } from "./carrier-error";

// Error toast for a failed `generate-label` call: the translated carrier cause
// ("Adresse … invalide") when the API gave one, the generic error otherwise.
export function useNotifyLabelGenerationFailure() {
  const t = useTranslation();
  const notifyError = useFormErrorNotif();

  return (error: unknown) => {
    const message = resolveLabelGenerationFailure(error, t);
    notifyError(message ? { message } : undefined);
  };
}
